import { v4 as uuidv4 } from 'uuid';
import { User } from '@shared';
import { complement, either, filter, isEmpty, isNil, not, pipe } from 'ramda';

export interface ColumnMapping {
  column: string;
  index: number;
}

export const normalizeCsv = (array: string[][]) => {
  const firstRow = array[0].map((i: string) => i.match(/^[^@]+@[^@]+\.[^@]+$/));
  const isSkip = pipe(filter(complement(either(isNil, isEmpty))), isEmpty, not)(firstRow);
  return array.slice(isSkip ? 0 : 1);
};

export type AddUsersValues = {
  isSkipExistingUsers: boolean;
  arrayColumnMapping: ColumnMapping[];
  files?: File[] | null;
  parsedData?: string[][] | null;
  invitedUsers?: User[];
};

export const normalizeInvitesUsers = (data: User[]) =>
  data.map((user) => ({ ...user, uuid: uuidv4() }));

export const convertCsvToUserFormat = ({
  data,
  columns,
}: {
  data?: string[][] | null;
  columns: ColumnMapping[];
}): User[] => {
  const result: User[] = [];

  data?.forEach((item) => {
    const person: User = {
      firstName: '',
      lastName: '',
      email: '',
    };

    columns.forEach((column) => {
      const value = item[column.index];
      if (column.column === 'firstName') {
        person.firstName = value;
      } else if (column.column === 'lastName') {
        person.lastName = value;
      } else if (column.column === 'email') {
        person.email = value;
      }
    });

    result.push(person);
  });

  return result;
};
